// // Set the date we're counting down to
// var countdownDate = new Date("Jul 20, 2017 12:00:00").getTime();

// // Update the count down every 1 second
// var x = setInterval(function() {

//   // Get date and time
//   var now = new Date().getTime();

//   // Find interval between now and the final date
//   var timeInterval = countdownDate - now;

//   // Time calculations for days, hours & minutes
//   var days = Math.floor(timeInterval / (1000 * 60 * 60 * 24));
//   var hours = Math.floor((timeInterval % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//   var minutes = Math.floor((timeInterval % (1000 * 60 * 60)) / (1000 * 60));

//   // Two digits
//   days = (String(days).length >= 2) ? days : "0" + days;
//   hours = (String(hours).length >= 2) ? hours : "0" + hours;
//   minutes = (String(minutes).length >= 2) ? minutes : "0" + minutes;

//   // Write to DOM
//   document.getElementsByClassName('days')[0].innerHTML = days;
//   document.getElementsByClassName('hours')[0].innerHTML = hours;
//   document.getElementsByClassName('minutes')[0].innerHTML = minutes;

// }, 1000);
